import { render, staticRenderFns } from "./ListActosViolencia.vue?vue&type=template&id=83241d5e&scoped=true&"
import script from "./ListActosViolencia.vue?vue&type=script&lang=js&"
export * from "./ListActosViolencia.vue?vue&type=script&lang=js&"
import style0 from "./ListActosViolencia.vue?vue&type=style&index=0&id=83241d5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83241d5e",
  null
  
)

export default component.exports